import angular from 'angular';
import {
    applyNsjTableInlineMobileLabels,
    buildNsjTableInlineMobileLabel,
    buildNsjTableManualInlineMobileLabel
} from '../../../../../utils/nsj-table';
import {
    MOVIMENTACAO_DISPLAY_MODE_OPTIONS,
    MOVIMENTACAO_ORDERING_OPTIONS,
    MOVIMENTACAO_STATUS_OPTIONS
} from '../../constants/movimentacoes.index.constants';
import {
    applyMovimentacaoStatusTotals,
    buildMovimentacaoResumoPlaceholder,
    getAvailableMovimentacaoBulkActions,
    getMovimentacaoBulkActionConfirmTexts,
    getMovimentacaoBulkActionErrorMessage,
    getMovimentacaoBulkActionSuccessMessage,
    getMovimentacaoSelectionBlockedReason,
    getMovimentacaoSelectionCounterLabel,
    getMovimentacaoSelectionScopeHint,
    getVisibleMovimentacaoStatusOptions,
    isMovimentacaoSelectableForBulkActions,
    resolveInitialMovimentacaoStatusByTotals,
    resolveMovimentacaoResumoDisplay,
    resolveVisibleMovimentacaoStatus
} from '../../helpers/movimentacoes-index-ui.helpers';
import {
    buildMovimentacoesLoteParcialMessage,
    chunkMovimentacoesLote,
    normalizeMovimentacoesLoteIds
} from '../../../helpers/movimentacoes-lote.helpers';
import {
    formatMovimentacaoListVigencia,
    getMovimentacaoDisplayStatusClass,
    getMovimentacaoDisplayStatusLabel,
    getMovimentacaoListEventoCodigo,
    getMovimentacaoListEventoNome,
    getMovimentacaoListLotacaoCodigo,
    getMovimentacaoListLotacaoNome,
    getMovimentacaoListPagamentoLabel,
    getMovimentacaoListRawValue,
    getMovimentacaoListReferenceLabel,
    isMovimentacaoListMonetaryValue
} from '../../helpers/movimentacoes-list-ui.helpers';
import {
    buildMovimentacaoGroupedListGroups,
    resolveMovimentacaoDisplayModeOrderingOption
} from '../../helpers/movimentacoes-grouped-list-ui.helpers';
import { extractMovimentacaoErrorMessage } from '../../helpers/movimentacoes-errors.helpers';
import {
    isMovimentacaoDataPagamentoEnabled,
    isMovimentacaoPeriodoEncerrado
} from '../../helpers/movimentacoes-form.helpers';
import {
    IMovimentacaoDisplayModeOption,
    IMovimentacaoGroupedListGroupView,
    IMovimentacaoListRefreshRequest,
    IMovimentacoesListagemBindings,
    TMovimentacaoListDisplayMode,
    TMovimentacaoListagemBulkAction
} from './movimentacoes-listagem.model';
import { ModalConfirmService } from '../../../../../shared/components/modal-confirm/modal.confirm.service';
import { MovimentacoesService } from '../../../movimentacoes.service';
import { MovimentacoesWorkflowService } from '../../../movimentacoes-workflow.service';
import {
    IMovimentacaoListItem,
    IMovimentacaoLoteChunkResult,
    IMovimentacaoResumoItem
} from '../../../models/movimentacoes.service.model';
import {
    IMovimentacaoBulkActionOption,
    IMovimentacaoOrderingOption,
    IMovimentacaoResumoDisplay,
    IMovimentacaoSelectionContext,
    IMovimentacaoUiStatusOption,
    TMovimentacaoUiStatusKey
} from '../../models/movimentacoes.index.model';
import { IMovimentacaoPeriodo } from '../../../models/movimentacoes-periodos.service.model';

export class MovimentacoesListagemController implements IMovimentacoesListagemBindings {

    static $inject = [
        '$q',
        '$scope',
        'NewToaster',
        'ModalConfirmService',
        'MovimentacoesService',
        'MovimentacoesWorkflowService'
    ];

    public selectedPeriod: IMovimentacaoPeriodo | null = null;
    public selectedStatus: IMovimentacaoUiStatusOption = MOVIMENTACAO_STATUS_OPTIONS[MOVIMENTACAO_STATUS_OPTIONS.length - 1];
    public statusOptions: IMovimentacaoUiStatusOption[] = [];
    public resumoDisplay: IMovimentacaoResumoDisplay = buildMovimentacaoResumoPlaceholder();
    public resumoLoaded = false;
    public workflowEnabled = false;
    public canManage = false;
    public currentUserEmail = '';
    public refreshRequest: IMovimentacaoListRefreshRequest | null = null;
    public onOpenDetail?: (args: { entity: IMovimentacaoListItem }) => void;
    public onChanged?: () => angular.IPromise<void> | void;

    public dataPagamentoEnabled = isMovimentacaoDataPagamentoEnabled();
    public searchTerm = '';
    public selectedOrdering: IMovimentacaoOrderingOption = MOVIMENTACAO_ORDERING_OPTIONS[0];
    public selectedDisplayMode: IMovimentacaoDisplayModeOption = MOVIMENTACAO_DISPLAY_MODE_OPTIONS[0];
    public displayModeOptions = MOVIMENTACAO_DISPLAY_MODE_OPTIONS;
    public bulkActions: IMovimentacaoBulkActionOption[] = [];
    public entities: IMovimentacaoListItem[] = [];
    public groupedEntities: IMovimentacaoGroupedListGroupView[] = [];
    public selectionMode = false;
    public selectionActionBusy = false;
    // fonte de verdade da seleção: referências das entidades carregadas, jamais cópias.
    public checkboxPreenchidos: IMovimentacaoListItem[] = [];
    // alias entregue ao nsj-table; `null` desliga a coluna de checkbox do componente.
    public selectionModel: IMovimentacaoListItem[] | null = null;
    public groupedTableMobileLabels = {
        selecao: buildNsjTableManualInlineMobileLabel('Selecionar', { showOnMobile: false }),
        colaborador: buildNsjTableManualInlineMobileLabel('Colaborador'),
        rubrica: buildNsjTableManualInlineMobileLabel('Rubrica'),
        valor: buildNsjTableManualInlineMobileLabel('Valor/Qtd.'),
        referencia: buildNsjTableManualInlineMobileLabel('Referência'),
        vigencia: buildNsjTableManualInlineMobileLabel('Vigência'),
        lotacao: buildNsjTableManualInlineMobileLabel('Lotação'),
        pagamento: buildNsjTableManualInlineMobileLabel('Pagamento'),
        status: buildNsjTableManualInlineMobileLabel('Status'),
        acoes: buildNsjTableManualInlineMobileLabel('Ações', { showOnMobile: false })
    };
    public fields = applyNsjTableInlineMobileLabels([
        {
            value: 'trabalhador.nome',
            label: 'Colaborador',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnScope: {
                resolveFoto: (entity: IMovimentacaoListItem): string => this.resolveFoto(entity)
            },
            customCollumnHtml: (): string => `
                <div class="mvm-index__colaborador" ng-init="customCollumnScope.resolveFoto(tableRowEntity)">
                    <img
                        class="mvm-index__colaborador-foto"
                        ng-if="tableRowEntity.colaboradorFotoUrl"
                        ng-src="{{tableRowEntity.colaboradorFotoUrl}}"
                        onerror="
                            this.src='https://s3-sa-east-1.amazonaws.com/imagens.nasajon/geral/avatar-3x4.svg';
                            this.style.objectFit='fill';
                        "
                        alt=""
                        aria-hidden="true"
                    />
                    <div class="mvm-index__colaborador-text">
                        <strong class="mvm-index__table-primary">{{tableRowEntity.trabalhador.nome}}</strong>
                        <div
                            ng-if="tableRowEntity.trabalhador.codigo"
                            class="mvm-index__table-secondary"
                        >
                            Matrícula: {{tableRowEntity.trabalhador.codigo}}
                        </div>
                    </div>
                </div>
            `
        },
        {
            value: 'evento.nome',
            label: 'Rubrica',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnScope: {
                getEventoNome: (entity: IMovimentacaoListItem): string => getMovimentacaoListEventoNome(entity),
                getEventoCodigo: (entity: IMovimentacaoListItem): string => getMovimentacaoListEventoCodigo(entity)
            },
            customCollumnHtml: (): string => `
                <div>
                    <strong>{{customCollumnScope.getEventoNome(tableRowEntity)}}</strong>
                    <div
                        ng-if="customCollumnScope.getEventoCodigo(tableRowEntity)"
                        class="mvm-index__table-secondary"
                    >
                        Código: {{customCollumnScope.getEventoCodigo(tableRowEntity)}}
                    </div>
                </div>
            `
        },
        {
            value: 'valor',
            label: 'Valor/Qtd.',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnScope: {
                isMonetaryValue: (entity: IMovimentacaoListItem): boolean => isMovimentacaoListMonetaryValue(entity),
                getRawValue: (entity: IMovimentacaoListItem): string => getMovimentacaoListRawValue(entity)
            },
            customCollumnHtml: (): string => `
                <span
                    ng-if="customCollumnScope.isMonetaryValue(tableRowEntity)"
                    ng-bind="tableRowEntity.valor | currency:'R$ ':2"
                ></span>
                <span ng-if="!customCollumnScope.isMonetaryValue(tableRowEntity)">
                    {{customCollumnScope.getRawValue(tableRowEntity)}}
                </span>
            `
        },
        {
            value: 'referencia',
            label: 'Referência',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnScope: {
                getReferenceLabel: (entity: IMovimentacaoListItem): string => getMovimentacaoListReferenceLabel(entity)
            },
            customCollumnHtml: (): string => `
                <span>{{customCollumnScope.getReferenceLabel(tableRowEntity)}}</span>
            `
        },
        {
            value: 'vigencia',
            label: 'Vigência',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnScope: {
                formatVigencia: (entity: IMovimentacaoListItem): string => formatMovimentacaoListVigencia(entity)
            },
            customCollumnHtml: (): string => `
                <span>{{customCollumnScope.formatVigencia(tableRowEntity)}}</span>
            `
        },
        {
            value: 'lotacao.nome',
            label: 'Lotação',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnScope: {
                getLotacaoNome: (entity: IMovimentacaoListItem): string => getMovimentacaoListLotacaoNome(entity),
                getLotacaoCodigo: (entity: IMovimentacaoListItem): string => getMovimentacaoListLotacaoCodigo(entity)
            },
            customCollumnHtml: (): string => `
                <div>
                    <strong>{{customCollumnScope.getLotacaoNome(tableRowEntity)}}</strong>
                    <div
                        ng-if="customCollumnScope.getLotacaoCodigo(tableRowEntity)"
                        class="mvm-index__table-secondary"
                    >
                        Código: {{customCollumnScope.getLotacaoCodigo(tableRowEntity)}}
                    </div>
                </div>
            `
        },
        {
            value: 'datapagamento',
            label: 'Pagamento',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnScope: {
                getPagamentoLabel: (entity: IMovimentacaoListItem): string => getMovimentacaoListPagamentoLabel(entity)
            },
            customCollumnHtml: (): string => `
                <span>{{customCollumnScope.getPagamentoLabel(tableRowEntity)}}</span>
            `
        },
        {
            value: 'situacao',
            label: 'Status',
            type: 'string',
            style: 'title',
            copy: '',
            customCollumnScope: {
                getStatusClass: (entity: IMovimentacaoListItem): string => getMovimentacaoDisplayStatusClass(entity, this.workflowEnabled),
                getStatusLabel: (entity: IMovimentacaoListItem): string => getMovimentacaoDisplayStatusLabel(entity, this.workflowEnabled)
            },
            customCollumnHtml: (): string => `
                <div>
                    <span class="label {{customCollumnScope.getStatusClass(tableRowEntity)}}">
                        {{customCollumnScope.getStatusLabel(tableRowEntity)}}
                    </span>
                </div>
            `
        },
        {
            value: 'movimentacao',
            label: 'Ações',
            type: 'div',
            style: 'title',
            copy: '',
            customLabelHtml: buildNsjTableInlineMobileLabel('Ações', { showOnMobile: false }),
            customCollumnScope: {
                openDetalhe: (entity: IMovimentacaoListItem): void => this.openDetalhe(entity)
            },
            customCollumnHtml: (): string => `
                <div class="display-flex justify-content-center justify-content-end-md">
                    <a
                        class="btn btn-tertiary btn-sm"
                        ng-click="customCollumnScope.openDetalhe(tableRowEntity)"
                        aria-label="Visualizar movimentação"
                        title="Visualizar movimentação"
                    >
                        Ver detalhes
                    </a>
                </div>
            `
        }
    ].filter((field) => field.value !== 'datapagamento' || isMovimentacaoDataPagamentoEnabled()));

    private initialized = false;
    private listBusy = false;
    private resumoBusy = false;
    private fotoCache = new Map<string, string>();
    private fotoLoading = new Set<string>();
    private resumoItems: IMovimentacaoResumoItem[] = [];
    // mapa derivado de `checkboxPreenchidos`, para consulta O(1) nos templates agrupados.
    private selectedIdsMap: { [movimentacao: string]: boolean } = {};
    private unwatchSelection: (() => void) | null = null;

    constructor(
        public $q: angular.IQService,
        public $scope: angular.IScope,
        public NewToaster: {
            pop: (opts: { type: string; title: string; body?: string }) => void;
        },
        public ModalConfirmService: ModalConfirmService,
        public MovimentacoesService: MovimentacoesService,
        public MovimentacoesWorkflowService: MovimentacoesWorkflowService
    ) {}

    public $onInit(): void {
        // o checklist-model muta `checkboxPreenchidos` por fora do controller; o watch mantém o mapa derivado.
        this.unwatchSelection = this.$scope.$watchCollection(
            () => this.checkboxPreenchidos,
            () => this.syncSelectedIdsMap()
        );

        this.syncWorkflowVisibilityState();
        this.syncListState();
        this.syncBulkActions();
        this.initialized = true;

        if (this.selectedPeriod?.movimentacaoperiodo) {
            this.refreshResumoAndMovimentacoes({ autoSelectStatus: true });
            return;
        }

        this.resetResumo();
        this.clearListState(true);
    }

    public $onChanges(changes: angular.IOnChangesObject): void {
        if (!this.initialized) {
            return;
        }

        if (!this.selectedPeriod?.movimentacaoperiodo) {
            this.exitSelectionMode();
            this.resetResumo();
            this.clearListState(true);
            this.syncBulkActions();
            return;
        }

        const periodChanged = this.didSelectedPeriodChange(changes.selectedPeriod);
        const workflowChanged = this.didPrimitiveChange<boolean>(changes.workflowEnabled);
        const refreshChanged = this.didRefreshRequestChange(changes.refreshRequest);

        // o período pode ter sido encerrado mantendo o mesmo id, caso em que `periodChanged` é falso;
        // revalidar as ações garante que o modo de seleção não sobreviva a um período sem mutação
        // (`syncBulkActions` aplica o gate do modo de seleção).
        if (changes.selectedPeriod && !changes.selectedPeriod.isFirstChange()) {
            this.syncBulkActions();
        }

        if (periodChanged) {
            this.exitSelectionMode();
            this.refreshResumoAndMovimentacoes({ autoSelectStatus: true });
            return;
        }

        if (workflowChanged) {
            const previousStatusValue = this.selectedStatus.value;
            this.syncWorkflowVisibilityState();
            this.syncResumoDisplay();
            this.syncBulkActions();

            if (previousStatusValue !== this.selectedStatus.value) {
                this.exitSelectionMode();
                this.reloadMovimentacoes();
            }

            return;
        }

        if (refreshChanged) {
            this.exitSelectionMode();
            this.refreshResumoAndMovimentacoes({
                preferredStatusValue: this.refreshRequest?.preferredStatusValue || null
            });
        }
    }

    public $onDestroy(): void {
        if (this.unwatchSelection) {
            this.unwatchSelection();
            this.unwatchSelection = null;
        }

        this.exitSelectionMode();
        this.fotoCache.clear();
        this.fotoLoading.clear();
        this.MovimentacoesService.resetState();
    }

    public onBuscaChange(): void {
        // mesma razão do guard de `selectStatus`: recarregar a listagem dentro do modo de seleção
        // migraria a seleção pelo índice das linhas do nsj-table. Hoje a toolbar sai do DOM no
        // modo, mas a invariante precisa viver no controller e não só no template.
        if (this.selectionMode) {
            return;
        }

        this.MovimentacoesService.setFilterTerm(this.searchTerm || '');
        this.reloadMovimentacoes();
    }

    public onDisplayModeChange(): void {
        if (this.selectionMode) {
            return;
        }

        const displayMode = this.selectedDisplayMode.value;

        if (displayMode === 'flat') {
            this.selectedOrdering = MOVIMENTACAO_ORDERING_OPTIONS[0];
        } else {
            const forcedOrdering = resolveMovimentacaoDisplayModeOrderingOption(displayMode, MOVIMENTACAO_ORDERING_OPTIONS);
            if (forcedOrdering) {
                this.selectedOrdering = forcedOrdering;
            }
        }

        this.syncListState();
        this.reloadMovimentacoes();
    }

    public selectStatus(status: IMovimentacaoUiStatusOption): void {
        // trocar de aba dentro do modo de seleção recarregaria a listagem e migraria a seleção
        // pelo índice das linhas do nsj-table; por isso a troca fica bloqueada.
        if (this.selectionMode) {
            return;
        }

        if (this.selectedStatus.value === status.value) {
            return;
        }

        this.selectedStatus = status;
        this.syncResumoDisplay();
        this.syncBulkActions();
        this.reloadMovimentacoes();
    }

    public loadMore(): void {
        if (!this.selectedPeriod || this.MovimentacoesService.loadParams.busy || this.MovimentacoesService.loadParams.finished) {
            return;
        }

        this.MovimentacoesService.loadMore()
            .then((entities) => {
                this.setEntities(entities);
            })
            .catch((error) => {
                this.handleError(error, 'Não foi possível carregar mais movimentações.');
            });
    }

    public isFlatDisplayMode(): boolean {
        return this.selectedDisplayMode.value === 'flat';
    }

    public isGroupedDisplayMode(): boolean {
        return !this.isFlatDisplayMode();
    }

    public shouldShowGroupedEventoColumn(): boolean {
        return this.selectedDisplayMode.value === 'group_by_trabalhador';
    }

    public shouldShowGroupedColaboradorColumn(): boolean {
        return this.selectedDisplayMode.value === 'group_by_evento';
    }

    public isGroupedListBusy(): boolean {
        return this.isGroupedDisplayMode() &&
            (this.listBusy || this.MovimentacoesService.loadParams.busy) &&
            !this.groupedEntities.length;
    }

    public shouldShowGroupedEmptyState(): boolean {
        return this.isGroupedDisplayMode() &&
            !this.isGroupedListBusy() &&
            !this.groupedEntities.length;
    }

    public getGroupedEventoNome(entity: IMovimentacaoListItem): string {
        return getMovimentacaoListEventoNome(entity);
    }

    public getGroupedEventoCodigo(entity: IMovimentacaoListItem): string {
        return getMovimentacaoListEventoCodigo(entity);
    }

    public getGroupedLotacaoNome(entity: IMovimentacaoListItem): string {
        return getMovimentacaoListLotacaoNome(entity);
    }

    public getGroupedLotacaoCodigo(entity: IMovimentacaoListItem): string {
        return getMovimentacaoListLotacaoCodigo(entity);
    }

    public getGroupedReferenceLabel(entity: IMovimentacaoListItem): string {
        return getMovimentacaoListReferenceLabel(entity);
    }

    public getGroupedVigenciaLabel(entity: IMovimentacaoListItem): string {
        return formatMovimentacaoListVigencia(entity);
    }

    public getGroupedPagamentoLabel(entity: IMovimentacaoListItem): string {
        return getMovimentacaoListPagamentoLabel(entity);
    }

    public getGroupedStatusClass(entity: IMovimentacaoListItem): string {
        return getMovimentacaoDisplayStatusClass(entity, this.workflowEnabled);
    }

    public getGroupedStatusLabel(entity: IMovimentacaoListItem): string {
        return getMovimentacaoDisplayStatusLabel(entity, this.workflowEnabled);
    }

    public isGroupedMonetaryValue(entity: IMovimentacaoListItem): boolean {
        return isMovimentacaoListMonetaryValue(entity);
    }

    public getGroupedRawValue(entity: IMovimentacaoListItem): string {
        return getMovimentacaoListRawValue(entity);
    }

    public hasBulkActions(): boolean {
        return this.bulkActions.length > 0;
    }

    public shouldShowBulkActions(): boolean {
        return this.canManage
            && this.hasBulkActions()
            && typeof this.selectedStatus.total === 'number'
            && this.selectedStatus.total > 0;
    }

    public isBulkActionsDisabled(): boolean {
        return this.listBusy || this.MovimentacoesService.loadParams.busy || this.selectionActionBusy;
    }

    public confirmBulkAction(action: TMovimentacaoListagemBulkAction): void {
        if (!this.canManage) {
            return;
        }

        if (!this.selectedPeriod) {
            this.handleError(
                { message: 'Selecione um período para executar a ação em lote.' },
                'Não foi possível executar a ação em lote.'
            );
            return;
        }

        if (isMovimentacaoPeriodoEncerrado(this.selectedPeriod)) {
            this.notifyPeriodoEncerrado();
            return;
        }

        if (this.isBulkActionsDisabled()) {
            return;
        }

        this.ModalConfirmService
            .open({}, 'movimentacoes-lote', false, getMovimentacaoBulkActionConfirmTexts(action))
            .result
            .then(() => this.executeBulkAction(action))
            .catch(() => undefined);
    }

    public canEnterSelectionMode(): boolean {
        // diferente de `shouldShowBulkActions`, aqui o critério é a lista carregada e não o total da aba,
        // porque a seleção só alcança o que já veio para a tela.
        return this.canManage
            && this.hasBulkActions()
            && this.entities.length > 0;
    }

    public shouldShowSelectionToggle(): boolean {
        return this.canEnterSelectionMode() && !this.selectionMode;
    }

    public enterSelectionMode(): void {
        if (!this.canEnterSelectionMode()) {
            return;
        }

        this.setSelectionMode(true);
        this.applySelectionEligibility();
    }

    public exitSelectionMode(): void {
        this.setSelectionMode(false);
        this.clearSelectionEligibility();
    }

    public limparSelecao(): void {
        this.checkboxPreenchidos.length = 0;
        this.syncSelectedIdsMap();
    }

    public isTabChangeBlocked(): boolean {
        return this.selectionMode;
    }

    public getSelectableEntities(): IMovimentacaoListItem[] {
        return this.entities.filter((entity) => this.isRowSelectable(entity));
    }

    public isRowSelectable(entity: IMovimentacaoListItem): boolean {
        return !!entity && !entity.disableCheckbox;
    }

    public isSelected(entity: IMovimentacaoListItem): boolean {
        return !!entity && !!this.selectedIdsMap[entity.movimentacao];
    }

    public temSelecaoAtiva(): boolean {
        return this.checkboxPreenchidos.length > 0;
    }

    public temTodosMarcados(): boolean {
        const selecionaveis = this.getSelectableEntities().length;

        return !!selecionaveis && this.checkboxPreenchidos.length >= selecionaveis;
    }

    public naoTemTodosMarcados(): boolean {
        return this.temSelecaoAtiva() && !this.temTodosMarcados();
    }

    public checar_todos(): void {
        if (this.temTodosMarcados()) {
            this.limparSelecao();
            return;
        }

        // as próprias instâncias de `entities`, sem angular.copy: o nsj-table destaca a linha por referência.
        this.setCheckboxPreenchidos(this.getSelectableEntities());
    }

    public getSelectionCountLabel(): string {
        return getMovimentacaoSelectionCounterLabel(
            this.checkboxPreenchidos.length,
            this.getSelectableEntities().length
        );
    }

    public getSelectionScopeHint(): string {
        return getMovimentacaoSelectionScopeHint(this.entities.length, this.selectedStatus.total);
    }

    public getSelectableGroupCount(group: IMovimentacaoGroupedListGroupView): number {
        return this.getSelectableGroupEntities(group).length;
    }

    public temTodosDoGrupoMarcados(group: IMovimentacaoGroupedListGroupView): boolean {
        const selecionaveis = this.getSelectableGroupEntities(group);

        return !!selecionaveis.length && selecionaveis.every((entity) => this.isSelected(entity));
    }

    public naoTemTodosDoGrupoMarcados(group: IMovimentacaoGroupedListGroupView): boolean {
        const selecionaveis = this.getSelectableGroupEntities(group);
        const marcados = selecionaveis.filter((entity) => this.isSelected(entity)).length;

        return marcados > 0 && marcados < selecionaveis.length;
    }

    public temSelecaoNoGrupo(group: IMovimentacaoGroupedListGroupView): boolean {
        return this.getSelectableGroupEntities(group).some((entity) => this.isSelected(entity));
    }

    public toggleGrupo(group: IMovimentacaoGroupedListGroupView): void {
        const selecionaveis = this.getSelectableGroupEntities(group);

        if (!selecionaveis.length) {
            return;
        }

        if (this.temTodosDoGrupoMarcados(group)) {
            selecionaveis.forEach((entity) => this.removeFromSelection(entity));
        } else {
            selecionaveis.forEach((entity) => this.addToSelection(entity));
        }

        this.syncSelectedIdsMap();
    }

    public getSelectionActionClass(action: IMovimentacaoBulkActionOption): string {
        return action.selectionTone === 'danger' ? 'btn btn-danger btn-sm' : 'btn btn-primary btn-sm';
    }

    public isSelectionActionDisabled(): boolean {
        return !this.temSelecaoAtiva() || this.isBulkActionsDisabled();
    }

    public confirmSelectionBulkAction(action: TMovimentacaoListagemBulkAction): void {
        if (!this.canManage) {
            return;
        }

        if (!this.selectedPeriod) {
            this.handleError(
                { message: 'Selecione um período para executar a ação em lote.' },
                'Não foi possível executar a ação em lote.'
            );
            return;
        }

        if (isMovimentacaoPeriodoEncerrado(this.selectedPeriod)) {
            this.notifyPeriodoEncerrado();
            return;
        }

        if (this.isSelectionActionDisabled()) {
            return;
        }

        const movimentacoes = this.collectSelectedIds();

        if (!movimentacoes.length) {
            return;
        }

        this.ModalConfirmService
            .open({}, 'movimentacoes-lote', false, getMovimentacaoBulkActionConfirmTexts(action, movimentacoes.length))
            .result
            .then(() => this.executeSelectionBulkAction(action, movimentacoes))
            .catch(() => undefined);
    }

    public resolveFoto(entity: IMovimentacaoListItem): string {
        return this.resolveColaboradorFoto(entity);
    }

    public openDetalhe(entity: IMovimentacaoListItem): void {
        if (!entity || !entity.movimentacao || !this.onOpenDetail) {
            return;
        }

        this.onOpenDetail({ entity });
    }

    private reloadMovimentacoes(): angular.IPromise<IMovimentacaoListItem[]> {
        if (!this.selectedPeriod?.movimentacaoperiodo) {
            this.clearListState(true);
            return this.$q.resolve([]);
        }

        this.listBusy = true;
        this.setEntities([]);
        this.syncListState();
        this.MovimentacoesService.constructors = {
            movimentacaoperiodo: this.selectedPeriod.movimentacaoperiodo
        };

        return this.MovimentacoesService.reload()
            .then((entities) => {
                this.setEntities(entities);
                return entities;
            })
            .catch((error) => {
                this.setEntities([]);
                this.handleError(error, 'Não foi possível carregar as movimentações.');
                return [];
            })
            .finally(() => {
                this.listBusy = false;
            });
    }

    private refreshResumoAndMovimentacoes(
        options: { autoSelectStatus?: boolean; preferredStatusValue?: TMovimentacaoUiStatusKey | null } = {}
    ): void {
        if (!this.selectedPeriod?.movimentacaoperiodo) {
            this.resetResumo();
            this.clearListState(true);
            this.syncBulkActions();
            return;
        }

        this.loadResumo(this.selectedPeriod.movimentacaoperiodo, options)
            .then(() => this.reloadMovimentacoes())
            .catch(() => undefined);
    }

    private clearListState(resetService: boolean = false): void {
        this.listBusy = false;
        this.setEntities([]);

        if (resetService) {
            this.MovimentacoesService.resetState();
        }
    }

    private resolveColaboradorFoto(entity: IMovimentacaoListItem): string {
        const trabalhadorId = entity?.trabalhador?.trabalhador;

        if (!trabalhadorId) {
            return '';
        }

        const cached = this.fotoCache.get(trabalhadorId);

        if (cached) {
            entity.colaboradorFotoUrl = cached;
            this.applyFotoToTrabalhador(trabalhadorId, cached);
            return cached;
        }

        if (this.fotoLoading.has(trabalhadorId)) {
            return '';
        }

        this.fotoLoading.add(trabalhadorId);
        this.MovimentacoesService.getTrabalhadorFoto(trabalhadorId)
            .then((url: string) => {
                if (!url) {
                    return;
                }

                this.fotoCache.set(trabalhadorId, url);
                entity.colaboradorFotoUrl = url;
                this.applyFotoToTrabalhador(trabalhadorId, url);
            })
            .catch(() => {
                // sem foto
            })
            .finally(() => {
                this.fotoLoading.delete(trabalhadorId);
            });

        return '';
    }

    private applyFotoToTrabalhador(trabalhadorId: string, url: string): void {
        const applyFoto = (items: IMovimentacaoListItem[]): void => {
            items
                .filter((item) => item?.trabalhador?.trabalhador === trabalhadorId)
                .forEach((item) => {
                    item.colaboradorFotoUrl = url;
                });
        };

        applyFoto(this.entities);

        if (this.MovimentacoesService.entities !== this.entities) {
            applyFoto(this.MovimentacoesService.entities);
        }
    }

    private syncListState(): void {
        this.MovimentacoesService.setFilterTerm(this.searchTerm || '');
        this.MovimentacoesService.setFilters({
            situacao: angular.copy(this.selectedStatus.filter),
            wkf_estado: angular.copy(this.selectedStatus.wkfEstado || undefined),
            fase: typeof this.selectedStatus.fase !== 'undefined'
                ? this.selectedStatus.fase
                : undefined
        });
        this.MovimentacoesService.setOrder(angular.copy(this.selectedOrdering.order));
    }

    private setEntities(entities: IMovimentacaoListItem[]): void {
        this.entities = Array.isArray(entities) ? entities : [];
        this.applySelectionEligibility();
        this.syncGroupedEntities();
    }

    private setSelectionMode(active: boolean): void {
        this.selectionMode = active;
        this.checkboxPreenchidos.length = 0;
        // `null` faz o nsj-table esconder a coluna de checkbox (hasCheckbox testa Array.isArray).
        this.selectionModel = active ? this.checkboxPreenchidos : null;
        this.syncSelectedIdsMap();
    }

    private setCheckboxPreenchidos(next: IMovimentacaoListItem[]): void {
        // mutação in-place: `selectionModel` é um alias e reatribuir o array o deixaria órfão.
        this.checkboxPreenchidos.length = 0;
        next.forEach((entity) => this.checkboxPreenchidos.push(entity));
        this.syncSelectedIdsMap();
    }

    private addToSelection(entity: IMovimentacaoListItem): void {
        if (!entity || this.isSelected(entity)) {
            return;
        }

        this.checkboxPreenchidos.push(entity);
        this.selectedIdsMap[entity.movimentacao] = true;
    }

    private removeFromSelection(entity: IMovimentacaoListItem): void {
        if (!entity) {
            return;
        }

        const index = this.checkboxPreenchidos.findIndex((item) => item.movimentacao === entity.movimentacao);

        if (index >= 0) {
            this.checkboxPreenchidos.splice(index, 1);
        }

        delete this.selectedIdsMap[entity.movimentacao];
    }

    private syncSelectedIdsMap(): void {
        const map: { [movimentacao: string]: boolean } = {};

        this.checkboxPreenchidos.forEach((entity) => {
            if (entity?.movimentacao) {
                map[entity.movimentacao] = true;
            }
        });

        this.selectedIdsMap = map;
    }

    private applySelectionEligibility(): void {
        if (!this.selectionMode) {
            return;
        }

        const context = this.buildSelectionContext();

        this.entities.forEach((entity) => {
            const selectable = isMovimentacaoSelectableForBulkActions(entity, this.bulkActions, context);

            entity.disableCheckbox = !selectable;
            entity.enableTooltip = !selectable;
            entity.checkboxTooltip = selectable
                ? ''
                : getMovimentacaoSelectionBlockedReason(entity, this.bulkActions, context);
        });
    }

    private clearSelectionEligibility(): void {
        this.entities.forEach((entity) => {
            entity.disableCheckbox = false;
            entity.enableTooltip = false;
            entity.checkboxTooltip = '';
        });
    }

    private enforceSelectionModeGate(): void {
        if (this.selectionMode && !this.canEnterSelectionMode()) {
            this.exitSelectionMode();
        }
    }

    private getSelectableGroupEntities(group: IMovimentacaoGroupedListGroupView): IMovimentacaoListItem[] {
        return (group?.rows || [])
            .map((row) => row.entity)
            .filter((entity) => this.isRowSelectable(entity));
    }

    private buildSelectionContext(): IMovimentacaoSelectionContext {
        return { currentUserEmail: this.currentUserEmail || '' };
    }

    private collectSelectedIds(): string[] {
        return normalizeMovimentacoesLoteIds(this.checkboxPreenchidos.map((entity) => entity?.movimentacao));
    }

    private syncGroupedEntities(): void {
        const displayMode = this.selectedDisplayMode.value as TMovimentacaoListDisplayMode;
        this.groupedEntities = buildMovimentacaoGroupedListGroups(this.entities, displayMode);
    }

    private syncBulkActions(): void {
        // o gate precisa rodar nos dois caminhos: sem permissão, sem período ou com período
        // encerrado o modo de seleção também tem de encerrar, senão a barra fica visível sem ações.
        if (!this.canManage || !this.selectedPeriod || isMovimentacaoPeriodoEncerrado(this.selectedPeriod)) {
            this.bulkActions = [];
            this.enforceSelectionModeGate();
            return;
        }

        this.bulkActions = getAvailableMovimentacaoBulkActions(this.selectedStatus.value, this.workflowEnabled);
        this.enforceSelectionModeGate();
    }

    private loadResumo(
        movimentacaoperiodo: string,
        options: { autoSelectStatus?: boolean; preferredStatusValue?: TMovimentacaoUiStatusKey | null } = {}
    ): angular.IPromise<IMovimentacaoResumoItem[]> {
        if (!movimentacaoperiodo) {
            this.resetResumo();
            return this.$q.resolve([]);
        }

        this.resumoBusy = true;

        return this.MovimentacoesService.getResumo(movimentacaoperiodo)
            .then((items) => {
                this.resumoLoaded = true;
                this.resumoItems = Array.isArray(items) ? items : [];
                this.syncResumoDisplay(!!options.autoSelectStatus, options.preferredStatusValue || null);
                this.syncBulkActions();

                return this.resumoItems;
            })
            .catch(() => {
                this.resetResumo();
                return [];
            })
            .finally(() => {
                this.resumoBusy = false;
            });
    }

    private resetResumo(): void {
        this.resumoBusy = false;
        this.resumoLoaded = false;
        this.resumoItems = [];
        this.resumoDisplay = buildMovimentacaoResumoPlaceholder();
        this.syncStatusTotals();
    }

    private syncResumoDisplay(
        autoSelectStatus: boolean = false,
        preferredStatusValue: TMovimentacaoUiStatusKey | null = null
    ): void {
        if (!this.resumoLoaded) {
            this.resumoDisplay = buildMovimentacaoResumoPlaceholder();
            this.syncStatusTotals(false, preferredStatusValue);
            return;
        }

        this.syncStatusTotals(autoSelectStatus, preferredStatusValue);
        this.resumoDisplay = resolveMovimentacaoResumoDisplay(this.selectedStatus.value, this.resumoItems);
    }

    private syncWorkflowVisibilityState(): void {
        this.statusOptions = getVisibleMovimentacaoStatusOptions(this.workflowEnabled);
        this.selectedStatus = resolveVisibleMovimentacaoStatus(this.selectedStatus, this.statusOptions);
        this.syncStatusTotals();
    }

    private syncStatusTotals(
        autoSelectStatus: boolean = false,
        preferredStatusValue: TMovimentacaoUiStatusKey | null = null
    ): void {
        this.statusOptions = applyMovimentacaoStatusTotals(this.statusOptions, this.resumoItems);

        if (preferredStatusValue) {
            const preferredStatus = this.statusOptions.find((status) => status.value === preferredStatusValue);

            if (preferredStatus) {
                this.selectedStatus = preferredStatus;
                return;
            }
        }

        if (autoSelectStatus) {
            this.selectedStatus = resolveInitialMovimentacaoStatusByTotals(this.statusOptions, this.selectedStatus);
            return;
        }

        this.selectedStatus = this.statusOptions.find((status) => status.value === this.selectedStatus.value)
            || resolveVisibleMovimentacaoStatus(this.selectedStatus, this.statusOptions);
    }

    private executeBulkAction(action: TMovimentacaoListagemBulkAction): angular.IPromise<void> {
        if (!this.canManage) {
            return this.$q.reject();
        }

        if (!this.selectedPeriod) {
            return this.$q.reject({ message: 'Selecione um período para executar a ação em lote.' });
        }

        if (isMovimentacaoPeriodoEncerrado(this.selectedPeriod)) {
            this.notifyPeriodoEncerrado();
            return this.$q.reject({ message: 'Períodos encerrados não permitem alterações em movimentações.' });
        }

        const periodoId = this.selectedPeriod.movimentacaoperiodo;

        return this.buildBulkActionRequest(action, periodoId)
            .then(() => this.$q.when(this.onChanged ? this.onChanged() : undefined))
            .then(() => {
                this.NewToaster.pop({
                    type: 'success',
                    title: getMovimentacaoBulkActionSuccessMessage(action)
                });
            })
            .catch((error) => {
                this.handleError(error, getMovimentacaoBulkActionErrorMessage(action));
                return this.$q.reject(error);
            });
    }

    /**
     * `movimentacoes` vazio preserva a semântica do fluxo antigo: o backend aplica a ação a
     * todas as movimentações elegíveis do período.
     */
    private buildBulkActionRequest(
        action: TMovimentacaoListagemBulkAction,
        periodoId: string,
        movimentacoes: string[] = []
    ): angular.IPromise<void> {
        if (action === 'send') {
            return this.MovimentacoesService.enviarLote(periodoId, movimentacoes);
        }

        if (action === 'delete') {
            return this.MovimentacoesService.excluirLote(periodoId, movimentacoes);
        }

        if (action === 'approve') {
            return this.MovimentacoesWorkflowService.executarWorkflowAcaoLote(periodoId, 'APROVAR', movimentacoes);
        }

        return this.MovimentacoesService.cancelarLote(periodoId, movimentacoes);
    }

    private executeSelectionBulkAction(
        action: TMovimentacaoListagemBulkAction,
        movimentacoes: string[]
    ): angular.IPromise<void> {
        if (!this.selectedPeriod) {
            return this.$q.reject({ message: 'Selecione um período para executar a ação em lote.' });
        }

        const periodoId = this.selectedPeriod.movimentacaoperiodo;
        const chunks = chunkMovimentacoesLote(movimentacoes);

        this.selectionActionBusy = true;

        return this.runBulkActionChunks(action, periodoId, chunks)
            .then((resultado) => {
                if (!resultado.erro) {
                    this.exitSelectionMode();

                    return this.$q.when(this.onChanged ? this.onChanged() : undefined)
                        .then(() => {
                            this.NewToaster.pop({
                                type: 'success',
                                title: getMovimentacaoBulkActionSuccessMessage(action)
                            });
                        });
                }

                if (resultado.processados > 0) {
                    // parte das fatias já foi confirmada no servidor: recarregar é obrigatório para
                    // a tela não continuar exibindo um estado que deixou de existir.
                    this.exitSelectionMode();

                    return this.$q.when(this.onChanged ? this.onChanged() : undefined)
                        .then(() => {
                            this.NewToaster.pop({
                                type: 'error',
                                title: getMovimentacaoBulkActionErrorMessage(action),
                                body: `${buildMovimentacoesLoteParcialMessage(resultado.processados, resultado.total)} ${extractMovimentacaoErrorMessage(resultado.erro) || ''}`.trim()
                            });
                        });
                }

                // nada foi processado: mantém o modo e a seleção para o usuário tentar novamente.
                this.handleError(resultado.erro, getMovimentacaoBulkActionErrorMessage(action));
                return this.$q.reject(resultado.erro);
            })
            .finally(() => {
                this.selectionActionBusy = false;
            });
    }

    /**
     * Executa as fatias em sequência e interrompe na primeira falha: um erro sistêmico
     * (período encerrado, permissão) se repetiria em todas as fatias restantes.
     */
    private runBulkActionChunks(
        action: TMovimentacaoListagemBulkAction,
        periodoId: string,
        chunks: string[][]
    ): angular.IPromise<IMovimentacaoLoteChunkResult> {
        const resultado: IMovimentacaoLoteChunkResult = {
            processados: 0,
            total: chunks.reduce((sum, chunk) => sum + chunk.length, 0)
        };

        return chunks
            .reduce(
                (chain, chunk) => chain.then(() => {
                    if (resultado.erro) {
                        return undefined;
                    }

                    return this.buildBulkActionRequest(action, periodoId, chunk)
                        .then(() => {
                            resultado.processados += chunk.length;
                        })
                        .catch((error) => {
                            resultado.erro = error;
                        });
                }),
                this.$q.resolve() as angular.IPromise<any>
            )
            .then(() => resultado);
    }

    private notifyPeriodoEncerrado(): void {
        this.NewToaster.pop({
            type: 'error',
            title: 'Período encerrado.',
            body: 'Períodos encerrados não permitem alterações em movimentações.'
        });
    }

    private handleError(error: any, fallbackTitle: string): void {
        const message = extractMovimentacaoErrorMessage(error) || fallbackTitle;

        this.NewToaster.pop({
            type: 'error',
            title: fallbackTitle,
            body: message !== fallbackTitle ? message : undefined
        });
    }

    private didSelectedPeriodChange(change: angular.IChangesObject<IMovimentacaoPeriodo | null> | undefined): boolean {
        if (!change || change.isFirstChange()) {
            return false;
        }

        const previousId = change.previousValue?.movimentacaoperiodo || null;
        const currentId = change.currentValue?.movimentacaoperiodo || null;

        return previousId !== currentId;
    }

    private didRefreshRequestChange(
        change: angular.IChangesObject<IMovimentacaoListRefreshRequest | null | undefined> | undefined
    ): boolean {
        if (!change || change.isFirstChange()) {
            return false;
        }

        return change.previousValue?.token !== change.currentValue?.token;
    }

    private didPrimitiveChange<T>(change: angular.IChangesObject<T> | undefined): boolean {
        if (!change || change.isFirstChange()) {
            return false;
        }

        return change.previousValue !== change.currentValue;
    }
}
